import { render } from "./DonationGroupDtlForm.vue?vue&type=template&id=230749f8"
import script from "./DonationGroupDtlForm.vue?vue&type=script&lang=js"
export * from "./DonationGroupDtlForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__